import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, $fullScreen }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-bottom: 0px;
    border-radius: 16px 16px 0px 0px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
    margin: ${$fullScreen ? '16px auto 0px' : '0 auto'};
    max-width: ${$fullScreen ? '880px' : '416px'};
    padding: 16px 24px;
    width: 100%;
  `}
`;

export const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
`;

export const Title = styled.span`
  ${({ theme, $fullScreen }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    max-width: 290px;
    ${$fullScreen && css`
      max-width: 100%;
      min-width: calc(100% - 40px);
      text-align: center;
    `}
  `}
`;

export const ScoreWrapper = styled.ul`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: center;
  list-style: none;
  max-width: 350px;
  margin: 16px auto 20px;
  padding: 0px;
`;

export const ScoreButton = styled.li`
  ${({ theme, $selected }) => css`
    border-radius: 16px;
    border: 1px solid ${$selected ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.highMedium};
    font-size: 1.9em;
    line-height:1;
    padding: 8px;
    cursor: ${$selected ? 'default' : 'pointer'};
    transition: border-color 250ms ease;
  `}
`;

export const ScoreLabelRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 8px auto 0px;
  max-width: 350px;
`;

export const ScoreLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const FeedbackWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 16px auto 0px;
  max-width: 350px;
  > div > div{ 
    height: 80px;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin: 16px auto;
`;

export const TextArea = styled.textarea`
  ${({ theme }) => css`
      border: 1px solid ${theme.v2.colors.neutral.highMedium};
      border-radius: 8px;
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xxs};
      padding: 16px;
      background-color: ${theme.v2.colors.neutral.highPure};
      color: ${theme.v2.colors.neutral.lowMedium};
      width: 100%;
      max-width: 336px;
      height: 48px;
      resize: vertical;
  `}
`;
